
import SwiperCarasoul from "../../../../component/SwiperCarasoul";
import { ReactComponent as LocationIcon } from "../../../../assets/location.svg";
import { events } from "../../../../constants/eventsData";

const EventLeftDetails = ({ eventData, data }) => {
  const {
    id = null,
    eventName = "",
    eventDescription,
    eventDate = "",
    eventStartTime = "",
    eventEndTime = "",
    eventMedia = [""],
  } = data?.event || {};

  const {
    venueAddress,
    venueAddressMapUrl,
    venueCity,
    venueState,
    venueCountry,
  } = data?.venue || {};
  return (
    <div className="w-full lg:w-[700px]">
      <SwiperCarasoul
        data={eventMedia || ["1727680458887-fallback.jpg"]}
        classes={"h-[200px] xs:h-[300px] sm:h-[429px] select-none"}
      />
      <h1 className="bg-clip-text text-transparent bg-gradient-to-t from-[#2E3E8D] to-[#4DB1E1] text-[22px] xs:text-[26px] inline-block font-semibold mt-[16px] mb-[6px]">
        {eventName}
      </h1>
      <div className="flex gap-1 mt-2">
        <LocationIcon />
        <span className="text-[12px] text-[#AFB1B9]">
          {venueAddress || "Dubai-United Arab Emirates"}
        </span>
      </div>

      <div className="mt-[30px]">
        <h2 className="text-[#24252D] text-[20px] font-medium">Description</h2>
        <p className="text-sm text-[#626570] mt-[8px]">
          {/* Global Rock Superstars Green Day will perform for the first time in
          the Middle East when they take to the stage at Dubai’s Expo City in a
          bespoke built 30,000-capacity open-air concert venue on January 27,
          2025.
          <br />
          <br />
          Presented by All Things Live Middle East, and supported by Dubai
          Calendar and Expo City Dubai, for one night only, the five-time Grammy
          Award-winners, made up of Billie Joe Armstrong, Mike Dirnt, and Tré
          Cool, are set to thrill UAE fans with some of their biggest hits. see
          more */}
          {eventDescription || ""}
        </p>
      </div>

      <div className="mt-[28px]">
        <h2 className="text-[#24252D] text-[20px] font-medium">
          Event Location
        </h2>
        <img
          src="/images/location-img.png"
          alt="Map of the event location"
          className="mt-[16px] w-full sm:h-[274px] object-cover rounded-[10px]"
        />
      </div>
      <div className="mt-[14px] flex items-center flex-wrap gap-2 sm:gap-0 justify-between">
        <div>
          <h3 className="font-medium text-[18px] text-blue-color">
            {venueCity}, {venueState}, {venueCountry}
          </h3>
          <p className="text-sm mt-[4px] text-[#626570]">
            {venueAddress || "Dubai-United Arab Emirates"}
          </p>
        </div>
        <h3 className="text-blue-color text-sm font-medium underline">
          Get Directions
        </h3>
      </div>
    </div>
  );
};

export default EventLeftDetails;
